import * as yup from "yup";
import {string} from "yup";
import i18n from "../../../AppSystem/i18n";

class AdminRequestInternalTransaction {
    constructor({
                    originOrgId = '',
                    destinationOrgId = '',
                    amount = 0,
                    message = '',
                    subtype = '',
                } = {}) {
        this.originOrgId = originOrgId;
        this.destinationOrgId = destinationOrgId;
        this.amount = amount;
        this.message = message;
        this.subtype = subtype;
    }

    static getAttributes(filter = null, validationSchema = null ,optionsData = null, customField = null) {

        const orgIdPlaceholder = i18n.t('formPlaceholder.selectOrg');
        const subtypePlaceholder = i18n.t('internalTransaction.selectSubtype');
        const fieldRequired = i18n.t('validationMessage.fieldRequired');

        const completeSchema = yup.object().shape({
            originOrgId: string().required(fieldRequired),
            destinationOrgId: string().required(fieldRequired),
            amount: string().required(fieldRequired).test('is-positive',  `${i18n.t('validationMessage.greater0')}`, value => {
                const numValue = parseFloat(value.replace(',', '.'));
                return !isNaN(numValue) && numValue > 0;
            }),
            message: string().nullable(),
        });

        let optionsOrg = []
        if (optionsData) {
            optionsData.orgId?.map(item => {
                optionsOrg?.push({
                    label: item.name + ' ('+ item.type +')',
                    value: item.id,
                    type: item.type
                });
            });
        }

        const subtypeOptions = [
            { label: 'Budgettilldelning', value: 'Budgettilldelning' },
            { label: 'Kostnadsersättning', value: 'Kostnadsersättning' },
            { label: 'Aktivitetsersättning (Lokala grupper)', value: 'Aktivitetsersättning' },
            { label: 'Återtag budget', value: 'Återtag budget' },
            { label: 'Reglering av kostnad', value: 'Reglering av kostnad' },
        ];

        const attributes =  {
            originOrgId :{
                'label': i18n.t('internalTransaction.from'),
                'form': {
                    'type': 'select',
                    'options': optionsOrg,
                    "search": true,
                    'default': '',
                    'placeholder': orgIdPlaceholder,
                    'validation': completeSchema.fields.originOrgId,
                },
                'value': (item) => item.originOrgId || "",
            },
            destinationOrgId :{
                'label': i18n.t('internalTransaction.to'),
                'form': {
                    'type': 'select',
                    'options': optionsOrg,
                    "search": true,
                    'default': '',
                    'placeholder': orgIdPlaceholder,
                    'validation': completeSchema.fields.destinationOrgId,
                },
                'value': (item) => item.destinationOrgId || "",
            },
            amount: {
                'label': i18n.t('modelLabel.amount'),
                'form': {
                    'type': 'number',
                    'placeholder': i18n.t('formPlaceholder.enterAmount'),
                    'validation': completeSchema.fields.amount,
                },
                'value': (item) => item.amount || '',
            },
            message: {
                'label': i18n.t('modelLabel.message'),
                'form': {
                    'type': 'textarea',
                    "rows": 1,
                    'placeholder': i18n.t('formPlaceholder.enterComment'),
                    'validation': completeSchema.fields.message,
                },
                'value': (item) => item.message || '',
            },
            subtype: {
                'label': i18n.t('internalTransaction.subtype'),
                'form': {
                    'type': 'select',
                    'options': subtypeOptions,
                    'default': '',
                    'placeholder': subtypePlaceholder,
                    'validation': string().required(fieldRequired),
                },
                'value': (item) => item.subtype || '',
            },
            newBalance: {
                'label': i18n.t('internalTransaction.newBalance'),
                'form': {
                    'type': 'number',
                    'placeholder': i18n.t('internalTransaction.newBalancePlaceholder'),
                    'validation': string().nullable(),
                },
            },
        };

        if (validationSchema === true) {
            return completeSchema;
        }
        return attributes;
    }
}

export default AdminRequestInternalTransaction;